// extracted by mini-css-extract-plugin
export default {"select":"bQ64sb"};